import { styled } from "@material-ui/core/styles";

const Wrapper = styled("div")({
  overflow: "auto",
  padding: 20,
});

export default Wrapper;
